module.exports = __webpack_public_path__ + "static/capsule-preview-champlain-1.5ac833b1.png";


//////////////////
// WEBPACK FOOTER
// ./images/capsule-preview-champlain-1.png
// module id = 891
// module chunks = 168707334958949